// Defaults
import ComponentManager from "./scripts/ComponentManager";

import LazyLoad from './scripts/LazyLoad';
import Subpage from '../src/Layout/Subpage';

LazyLoad.init();